.nav-container {
  padding: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-end;

  .hamburger-menu {
    display: none;
  }

  .nav-wrapper {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;

    ul::-webkit-scrollbar {
      display: none;
    }

    ul {
      list-style: none;
      margin: 0;

      -ms-overflow-style: none;
      scrollbar-width: none;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      align-items: center;

      li {
        min-height: 92px;
      }

      a {
        display: block;
        padding-top: 37px;
        padding-bottom: 37px;
        padding-right: 12px;
        padding-left: 12px;
        color: #717171;
        text-decoration: none;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        text-transform: inherit;

        &:hover {
          color: #222;
        }

        &.link-active {
          color: #222;
          font-weight: 600;
        }
      }

      .demo {
        margin-left: 30px;
        min-height: inherit;

        a {
          border: 2px solid #0076C0;
          padding: 14px 24px;
          color: #0076C0;
          font-weight: 600;
        }
      }
    }
  }
}

@media (max-width: 995px) {
  .nav-container {
    .nav-wrapper {
      background: #fff;
      position: fixed;
      left: 0;
      width: 100%;
      left: -100%;
      height: 100%;
      z-index: 13;
      transition: transform 0.2s ease-in-out;
      transition: all 0.2s linear;
      -webkit-transition: all 0.2s linear;

      ul {
        display: block;
        padding: 0;

        li {
          min-height: 49px;

          a {
            border-bottom: 1px solid #ededed;
            display: block;
            padding: 15px 20px;
          }

          &.item:last-child:not(.demo) {
            a {
              border: 0;
            }
          }

          &.demo {
            margin: 0;
            padding: 15px 20px;

            .item-link {
              display: inline-block;
            }
          }
        }
      }
    }

    .hamburger-menu {
      background: url(../../assets/icon/i_hamburger-menu.svg) no-repeat center center;
      background-size: 40px 40px;
      display: block;
      width: 40px;
      height: 40px;
    }

    &.open {
      .hamburger-menu {
        .overlay {
          background: #000;
          opacity: 0.6;
          position: fixed;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 13;
        }
      }

      .nav-wrapper {
        display: block;
        top: 0;
        left: 0;
        width: 80%;
        height: 100%;
        z-index: 14;
        transition: all 0.2s linear;
        -webkit-transition: all 0.2s linear;
      }
    }
  }
}
